import { render, staticRenderFns } from "./xhs-sunGift-dialog.vue?vue&type=template&id=cbc70be0&scoped=true"
import script from "./xhs-sunGift-dialog.vue?vue&type=script&lang=js"
export * from "./xhs-sunGift-dialog.vue?vue&type=script&lang=js"
import style0 from "./xhs-sunGift-dialog.vue?vue&type=style&index=0&id=cbc70be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc70be0",
  null
  
)

export default component.exports